export const Lang = {
    title: 'Current Announcement',
    labels: {
        title: 'Title',
        description: 'Description',
        link_label: 'URL Label',
        link_location: 'URL',
    },
    actions: {
        save: 'Save Announcement',
        remove: 'Clear',
        cancel: 'Cancel',
    },
    toast: {
        success: 'Announcement saved',
        remove: 'Announcement cleared',
        error: 'Oops! Something went wrong!',
    },
    form: {
        title: {
            required: 'Title is required for Announcement.',
            maxLength: 'Title should not be longer than 25 characters.',
        },
        description: {
            required: 'Description body text is required for Announcement.',
            maxLength: 'Description body text should not be longer than 150 characters.',
        },
    },
};
